import React from 'react'
import ReactDOM from 'react-dom'
import Layout from './../components/layout';

import {
    DesktopRowMobileColumn,
    DesktopRow33MobileColumn100,
    DesktopRow66MobileColumn100
} from './../components/responsive'


function TableSummary(props) {
    return(
        <div className={`layout-row layout-justify-space-between layout-align-center my-summary-row ${props.className}`}>
            <div>{props.row[0]}</div>
            <div className="my-summary-total">{props.row[1]}</div>
        </div>
    )
}

function MyTable(props) {

    let data = props.data

    let colClass = ["flex-50", "flex-25", "flex-25"]
    if ( data.classes.length === 2 ) {
        colClass = ["flex-50","flex-50"]
    }

    let addonClassName = data.classes

    let headers = (data.headers || [] ).map( (p,i) => {
        return <div key={`${i}-header`} className={`my-table-cell ${colClass[i]} ${addonClassName[i]}`}>{p}</div>
    })

    let rows = data.rows.map( (row,i) => {
        let elems = row.map( (p, i) => {
            return <div key={`${i}-elem`} className={`my-table-cell ${colClass[i]} ${addonClassName[i]}`}>{p}</div>
        })

        return  <div className="my-table-row layout-row" key={`${i}-row`}>{elems}</div>
    })

    return (
        <div className={`my-table layout-column flex ${props.hideBorder ? "" : "whiteframe-z1"}`}>
            {headers.length !== 0 ?
                <div className="layout-row my-table-heading">
                    {headers}
                </div>
                : null }
            {rows}
            {props.children}
        </div>
    )
}

export function niceNumber(n) {
    if(n === "" || n === " ")
        return ""
    else
        return (+(n.replace(/,/g, ""))).toFixed(2);
}

function updateDimensions() {
    //todo client width - draw width if nav is open
    if(ReactDOM.findDOMNode(this)){
        const parent = ReactDOM.findDOMNode(this).parentNode
        let scale = parent.offsetWidth / 1000
        if(scale > 1){
            scale = 1
        }

        let fixedWidth = parent.offsetWidth
        if(parent.offsetWidth < 1000){
            fixedWidth = 1000
        }
        this.setState({scale, fixedWidth});
    }
}

class Body extends React.Component {

    constructor(props){
        super(props)
        this.state = {"scale": 1, "fixedWidth": 1000}
        this.updateDimensions = updateDimensions.bind(this)
    }

    yearToDate() {
        let data = {
            classes: ["","align-right"],
            headers: ["Year to date", "Value"],
            rows:
                this.props.payslip.year_to_date.map( (obj) => {
                    let key = Object.keys(obj)[0]
                    return [key, niceNumber(obj[key])]
                })
        }

        return <MyTable data={data}/>
    }

    deductions() {
        let data = {
            classes: ["", "align-right"],
            headers: ["Deductions", "Value"],
            rows:
                this.props.payslip.deductions.map( (obj) => {
                    let key = Object.keys(obj)[0]
                    return [key, niceNumber(obj[key])]
                })
        }

        return <MyTable data={data}/>
    }

    payments() {
        let data = {
            classes: ["", "align-right", "align-right"],
            headers: ["Payments", "Units", "Value"],
            rows:
                this.props.payslip.payments.map( (obj) => {
                    let key = Object.keys(obj)[0]
                    return [key, niceNumber(obj[key][0]), niceNumber(obj[key][1]) ]
                })
        }

        return <MyTable data={data}/>
    }

    holiday() {
        let data = {
            classes: ["",""],
            rows:
                this.props.payslip.holiday.map( (obj) => {
                    let key = Object.keys(obj)[0]
                    return [key, obj[key]]
                })
        }

        return <MyTable data={data}/>
    }

    taxData() {
        let data = {
            classes: ["",""],
            rows:
                this.props.payslip.tax_data.map( (obj) => {
                    let key = Object.keys(obj)[0]
                    return [key, obj[key]]
                })
        }

        return <MyTable data={data}/>
    }

    payslipDates() {
        let pay_period = this.props.payslip.pay_period

        let data = {
            classes: ["", ""],
            rows: [
                ["Period Ending",  pay_period.period_ending],
                ["Payment Due Date",  pay_period.payment_due_date],
                ["Tax Week",  pay_period.tax_week],
            ]
        }

        return <MyTable data={data} hideBorder={true}/>
    }


    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    render() {
        if(this.props.store.desktopLayout){
            return (
                <div className="gutters" ref="content" 
                    style={{
                        position: "absolute", 
                        minWidth: this.state.fixedWidth + "px", 
                        minHeight: "100%", 
                        transform: "scale("+this.state.scale+")", 
                        WebkitTransform: "scale("+this.state.scale+")", 
                        transformOrigin: "top left",
                        WebkitTransformOrigin: "top left"
                    }}>
                    <div className="gutters-row layout-row flex">
                        <div className="layout-row flex-33">
                            <div id="pay_period" className="layout-row flex">
                                {this.payslipDates()}
                            </div>
                        </div>
                    </div>

                    <div className="gutters-row layout-row flex">

                        <div className="layout-row flex-33">
                            <div className="layout-row flex">
                                <div id="payments" className="layout-column flex">
                                    {this.payments()}
                                    <TableSummary row={["Total Payments", niceNumber(this.props.payslip.colleague_data.total_payments)]}/>
                                </div>
                            </div>
                        </div>

                        <div className="layout-row flex-33">
                            <div className="layout-row flex">
                                <div id="deductions" className="layout-column flex">
                                    {this.deductions()}
                                    <TableSummary row={["Total Deductions", niceNumber(this.props.payslip.colleague_data.total_deductions)]}/>
                                </div>
                            </div>
                        </div>

                        <div className="layout-row flex-33">
                            <div className="layout-row flex">
                                <div id="year_to_date" className="layout-column flex">
                                    {this.yearToDate()}
                                    <TableSummary row={["Net pay", niceNumber(this.props.payslip.colleague_data.net_pay)]} className="net-pay"/>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="gutters-row layout-row flex">

                        <div className="layout-row flex-66">
                            <div id="holiday" className="layout-column flex">
                                {this.holiday()}
                            </div>
                        </div>

                        <div className="layout-row flex-33">
                            <div id="tax_data" className="layout-column flex">
                                {this.taxData()}
                            </div>
                        </div>
                    </div>
                    <br/><br/><br/>
                </div>
            )
        } else {
            return (
                <div className="gutters">
                    <DesktopRowMobileColumn className="gutters-row">
                        <DesktopRow33MobileColumn100>
                            <div id="pay_period" className="layout-row flex">
                                {this.payslipDates()}
                            </div>
                        </DesktopRow33MobileColumn100>
                    </DesktopRowMobileColumn>

                    <DesktopRowMobileColumn className="gutters-row">

                        <DesktopRow33MobileColumn100>
                            <div className="layout-row flex">
                                <div id="payments" className="layout-column flex">
                                    {this.payments()}
                                    <TableSummary row={["Total Payments", niceNumber(this.props.payslip.colleague_data.total_payments)]}/>
                                </div>
                            </div>
                        </DesktopRow33MobileColumn100>

                        <DesktopRow33MobileColumn100>
                            <div className="layout-row flex">
                                <div id="deductions" className="layout-column flex">
                                    {this.deductions()}
                                    <TableSummary row={["Total Deductions", niceNumber(this.props.payslip.colleague_data.total_deductions)]}/>
                                </div>
                            </div>
                        </DesktopRow33MobileColumn100>

                        <DesktopRow33MobileColumn100>
                            <div className="layout-row flex">
                                <div id="year_to_date" className="layout-column flex">
                                    {this.yearToDate()}
                                    <TableSummary row={["Net pay", niceNumber(this.props.payslip.colleague_data.net_pay)]} className="net-pay"/>
                                </div>
                            </div>
                        </DesktopRow33MobileColumn100>

                    </DesktopRowMobileColumn>
                    <DesktopRowMobileColumn className="gutters-row">

                        <DesktopRow66MobileColumn100>
                            <div id="holiday" className="layout-column flex">
                                {this.holiday()}
                            </div>
                        </DesktopRow66MobileColumn100>

                        <DesktopRow33MobileColumn100>
                            <div id="tax_data" className="layout-column flex">
                                {this.taxData()}
                            </div>
                        </DesktopRow33MobileColumn100>
                    </DesktopRowMobileColumn>
                    <br/><br/><br/>
                </div>

            )
        }
    }

}


export default class Page extends React.Component {

    render() {
        const payslip = this.props.payslip

        const payment_due_date = (payslip.pay_period && payslip.pay_period.payment_due_date) || ""

        let errorMessage = null

        if ( payslip.http_status === 404 ) errorMessage = "You do not have any payslips yet"
        if ( payslip.treat_as_error ) errorMessage = "Error retrieving payslip information"

        const title = `${this.props.title || 'Payslip'} ${payment_due_date}`

        return (
            <Layout title={title}
                    showAppBarActions={true}
                    location={this.props.location}
                    store={this.props.store}
                    browser={this.props.browser}
                    ready={payslip.ready}
                    errorMessage={ errorMessage }
                    payslip={this.props.payslip}
                    body={Body}>
            </Layout>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/payslip.js